export default __webpack_public_path__ + "static/media/gallery_01.20872d2a.jpg";